import React from 'react'
import { useTranslation } from 'react-i18next'
// mui components
import {
  makeStyles,
  Table,
  TableBody,
  TableCell,
  TableRow,
  Grid
} from '@material-ui/core'
import { proposalStatusOptions } from '../../lib/Constants'

const useStyles = makeStyles(
  /** @type {(any) => any} */ theme => ({
    commonStatus: {
      color: 'white',
      width: '145px',
      minWidth: '100px',
      height: '45px',
      textAlign: 'center',
      fontSize: '13px',
      fontWeight: '600',
      border: '1px solid',
      transition: 'transform 380ms',
      '&:hover': {
        transform: 'scale(1.1)'
      }
    },
    draft: {
      backgroundColor: theme.colors.proposalColors.draft_transparent,
      '&:hover': {
        backgroundColor: theme.colors.proposalColors.draft
      }
    },
    approved: {
      backgroundColor: theme.colors.proposalColors.approved_transparent,
      '&:hover': {
        backgroundColor: theme.colors.proposalColors.approved
      }
    },
    declined: {
      backgroundColor: theme.colors.proposalColors.rejected_transparent,
      '&:hover': {
        backgroundColor: theme.colors.proposalColors.rejected
      }
    },
    in_review: {
      backgroundColor: theme.colors.proposalColors.in_review_transparent,
      '&:hover': {
        backgroundColor: theme.colors.proposalColors.in_review
      }
    },
    pending_decision: {
      backgroundColor: theme.colors.proposalColors.pending_decision_transparent,
      '&:hover': {
        backgroundColor: theme.colors.proposalColors.pending_decision
      }
    },
    draftBorder: {
      borderRadius: '10px 0px 0px 10px'
    },
    tableRow: {
      [theme.breakpoints.down('xs')]: {
        display: 'grid',
        gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
        '& td': {
          width: '100%',
          padding: '10px 41px',
          height: 'auto',
          borderRadius: '0'
        },
        '& td:hover': {
          transform: 'none',
          filter: 'brightness(75%)'
        }
      },
      [theme.breakpoints.only('sm')]: {
        display: 'grid',
        gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
        '& td': {
          width: '100%',
          padding: '10px 41px',
          height: 'auto',
          borderRadius: '0'
        },
        '& td:hover': {
          transform: 'none',
          filter: 'brightness(75%)'
        }
      }
    }
  })
)

function StatusBar(props) {
  const { content, setSearchStatus } = props
  const classes = useStyles()
  const { t } = useTranslation()

  const handleClick = (event, data) => {
    setSearchStatus(data.toLowerCase())
  }

  return (
    <Grid container justifyContent="flex-end">
      <Table sx={{ minWidth: 650 }} aria-label="simple table">
        <TableBody>
          <TableRow className={classes.tableRow}>
            {proposalStatusOptions.map(status => {
              const row = content?.find(row => row.status === status) || {
                count: 0,
                status
              }
              const className = `${classes.commonStatus} ${
                classes[status] || ''
              } ${status === 'draft' ? classes.draftBorder : ''}`
              return (
                <TableCell
                  key={'summary-' + status}
                  classes={{ root: className }}
                  onClick={event => handleClick(event, status)}
                >
                  {row.count} {t('proposals.status.' + status)}
                </TableCell>
              )
            })}
          </TableRow>
        </TableBody>
      </Table>
    </Grid>
  )
}

export const ProposalStatusBar = props => {
  const { content, setSearchStatus } = props
  return (
    <div>
      <StatusBar content={content} setSearchStatus={setSearchStatus} />
    </div>
  )
}
